import { delete_, get, post, put } from ".";

export const changeProfileUser = (data) => {
  return put(`/api/user/setPic`, true, data);
};
export const changeGroupCodeUser = (code) => {
  return put(`/api/user/setGroup/${code}`, true);
};
export const changeProfileGroup = (data) => {
  return post(`/api/group/group/setPic`, true, data);
};
export const getNotes = () => {
  return get(`/api/public/note/list`, true);
};
export const noteStore = (data) => {
  return post(`/api/public/note/store`, true, data);
};
export const updateInfo = (data) => {
  return post(`/api/user/update`, true, data);
};
export const changePassword = (data) => {
  return post(`/api/user/changePassword`, true, data);
};
export const changePhone = (data) => {
  return post(`/api/user/changePhone`, true, data);
};
export const doChangePhone = (data) => {
  return post(`/api/user/doChangePhone`, true, data);
};
export const getDigest = () => {
  return get(`/api/user/digest`, true);
};
export const logout = () => {
  return delete_(`/api/user/logout`, true);
};
export const deleteNote = (noteId) => {
  return delete_(`/api/public/note/remove/${noteId}`, true);
};
